// extracted by mini-css-extract-plugin
export default {"container":"countdown_container__l3uWW","title":"countdown_title__x5-+v"};